import { useModel as _useModel, useCssVars as _useCssVars, unref as _unref, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "k-colour-picker q-px-md q-pt-md q-pb-lg shadow-3 bg-white rounded-16" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-12 no-wrap q-mb-md"
}
const _hoisted_3 = { class: "items-center row gap-12" }

import { toValue, ref, toRef } from 'vue'

interface IEmits {
  (event: 'cancel'): void
}

interface IProps {
  hasInput?: boolean
  hasTransparency?: boolean
  doneLabel?: string
  cancelLabel?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KColourPicker' },
  __name: 'KColourPicker',
  props: /*@__PURE__*/_mergeModels({
    hasInput: { type: Boolean, default: true },
    hasTransparency: { type: Boolean, default: true },
    doneLabel: { default: 'Pick' },
    cancelLabel: { default: 'Cancel' }
  }, {
    "modelValue": { type: String, required: true },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["cancel"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "c4305e7c": (colourRef.value),
  "d7d44a90": (alfaBarColorRef.value)
}))




const emit = __emit

const modelValue = _useModel(__props, "modelValue")

const colourRef = ref(toValue(() => modelValue.value))

const alfaBarColorRef = toRef(() => colourRef.value.slice(0, 7) || '#757575')

function handlePickColor() {
  modelValue.value = colourRef.value
  emit('cancel')
}

return (_ctx: any,_cache: any) => {
  const _component_q_color = _resolveComponent("q-color")!
  const _component_k_input = _resolveComponent("k-input")!
  const _component_k_btn = _resolveComponent("k-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_color, {
      modelValue: colourRef.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((colourRef).value = $event)),
      "format-model": __props.hasTransparency ? 'hexa': 'hex',
      flat: "",
      "no-header": "",
      "no-footer": ""
    }, null, 8 /* PROPS */, ["modelValue", "format-model"]),
    (__props.hasInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "q-mb-none fs-15px fw-500 text-cool-gray-100" }, "Hex:", -1 /* CACHED */)),
          _createVNode(_component_k_input, {
            "input-class": "text-uppercase",
            placeholder: "#000000",
            small: "",
            modelValue: colourRef.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((colourRef).value = $event))
          }, null, 8 /* PROPS */, ["modelValue"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_k_btn, {
        class: "flex-1",
        model: "secondary",
        size: "sm",
        label: __props.cancelLabel,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
      }, null, 8 /* PROPS */, ["label"]),
      _createVNode(_component_k_btn, {
        class: "flex-1",
        size: "sm",
        label: __props.doneLabel,
        onClick: handlePickColor
      }, null, 8 /* PROPS */, ["label"])
    ])
  ]))
}
}

})